import { render, staticRenderFns } from "./AgendaSlotComponent.vue?vue&type=template&id=2b3ea1e1&scoped=true"
import script from "./AgendaSlotComponent.vue?vue&type=script&lang=js"
export * from "./AgendaSlotComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaSlotComponent.vue?vue&type=style&index=0&id=2b3ea1e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3ea1e1",
  null
  
)

export default component.exports